import React from 'react';
import PaymentMethodPanel from "./PaymentMethodPanel";
import { anchorCdnUrl } from "../../constants";
const brandLogos = {
  jcb: 'jcb.svg',
  amex: 'amex.svg',
  visa: 'visa.svg',
  mastercard: 'mastercard.svg',
  discover: 'discover.svg',
  diners: 'diners-club.svg',
  unionpay: 'unionpay.svg'
};
const defaultCardLogo = 'default-card.svg';
export default function CreditCardPanel(props) {
  const {
    creditCard,
    isSelected,
    isMobile,
    removable,
    selectable,
    onSelect,
    onRemove
  } = props;
  const {
    last4,
    creditCard: {
      brand,
      expiry
    }
  } = creditCard;
  return /*#__PURE__*/React.createElement(PaymentMethodPanel, {
    isSelected: isSelected,
    isMobile: isMobile,
    removable: removable,
    selectable: selectable,
    onRemove: onRemove,
    onSelect: onSelect,
    title: "Credit Card",
    description: "****".concat(last4).concat(expiry ? " (Expires ".concat(expiry.month, "/").concat(expiry.year, ")") : ''),
    logo: /*#__PURE__*/React.createElement("img", {
      alt: "credit card logo",
      "data-testid": "credit-card-logo",
      src: "".concat(anchorCdnUrl, "/images/credit-cards/").concat(brandLogos[brand] || defaultCardLogo)
    })
  });
}